import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
} from "@mui/material";
import { callAPI } from "../../App/Helpers/callApi";
import Signifier from "../../App/Components/Signifier/Signifier";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../App/State/Slices/SelectedCareersClientSlice";
import Breadcrumb from "../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { editEmailApplyLink, getEmailApplyLink } from "./EmailApplyLinkService";

function EmailApplyLinkPage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    cardContainer: {
      [theme.breakpoints.down("md")]: {
        width: "100%",
        overflowY: "scroll",
      },
      display: "flex",
      flexDirection: "column",
      marginBottom: "20px",
      width: "50%",
    },
    error: {
      color: theme.palette.error.main,
    },
    copy: {
      color: theme.palette.primary.copy,
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);

  const [useLink, setUseLink] = useState(false);
  const [applyLink, setApplyLink] = useState(false);
  const [width, setWidth] = useState(0);
  const [preText, setPreText] = useState("");
  const [postText, setPostText] = useState("");

  function saveEmailApply() {
    let data = {
      ClientId: selectCareersClient.id,
      HasEmailApply: useLink,
      UseApplyLink: applyLink,
      PreText: preText,
      PostText: postText,
      ActivateResolution: width,
    };

    callAPI(
      editEmailApplyLink(data),
      "Email Apply Link Saved",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getEmailApplyLink(selectCareersClient.id).then((response) => {
        setUseLink(response.hasEmailApply);
        setApplyLink(response.useApplyLink);
        setWidth(response.activateResolution);
        setPreText(response.preText === null ? "" : response.preText);
        setPostText(response.postText === null ? "" : response.postText);
      });
    });
  }

  useEffect(() => {
    if (selectCareersClient !== null) {
      getEmailApplyLink(selectCareersClient.id).then((response) => {
        setUseLink(response.hasEmailApply);
        setApplyLink(response.useApplyLink);
        setWidth(response.activateResolution);
        setPreText(response.preText === null ? "" : response.preText);
        setPostText(response.postText === null ? "" : response.postText);
      });
    }
  }, [selectCareersClient]);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">
          {selectCareersClient.shortName} Email Apply Link
        </h1>
        <div className={classes.root}>
          <Grid className={classes.cardContainer}>
            <Card className={classes.card}>
              <CardContent>
                <Grid container spacing={1}>
                  <Grid xs={12} sm={4} item>
                    <FormControlLabel
                      style={{ marginTop: "10px" }}
                      className={classes.copy}
                      control={
                        <Checkbox
                          color="primary"
                          checked={useLink}
                          onChange={() => setUseLink(!useLink)}
                        />
                      }
                      label="Use Email Apply Link"
                    />
                  </Grid>
                  <Grid xs={12} sm={8} item>
                    <FormControlLabel
                      style={{ marginTop: "10px" }}
                      className={classes.copy}
                      control={
                        <Checkbox
                          color="primary"
                          checked={applyLink}
                          onChange={() => setApplyLink(!applyLink)}
                        />
                      }
                      label="Apply Link (Checked) - Job Description (Unchecked)"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      placeholder="Activate Screen Width"
                      label="Activate Screen Width"
                      variant="standard"
                      fullWidth
                      required
                      type="number"
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={width}
                      onChange={(e) => setWidth(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      placeholder="Modal Pre Text"
                      label="Modal Pre Text"
                      variant="standard"
                      fullWidth
                      required
                      value={preText}
                      onChange={(e) => setPreText(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      placeholder="Modal Post Text"
                      label="Modal Post Text"
                      variant="standard"
                      fullWidth
                      required
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={postText}
                      onChange={(e) => setPostText(e.target.value)}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    container
                    justifyContent="flex-end"
                  >
                    <Button
                      style={{ marginTop: "20px", marginRight: "8px" }}
                      className={classes.sensitiveButton}
                      type="submit"
                      variant="contained"
                      color="primary"
                      onClick={() => saveEmailApply()}
                    >
                      Save Information
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </div>
      </div>
    </>
  );
}

export default EmailApplyLinkPage;
